import React from 'react';
import { Banners } from '../../components/service/common/BannerSlider/BannerSlider';
export const BannerPageView = () => {
  return <Banners data-sentry-element="Banners" data-sentry-component="BannerPageView" data-sentry-source-file="banner.tsx" />;
};